import * as GiftValue from '../../../../constants/giftValue';
import * as InformationText from '../../../../constants/informationText';

class GiftDetailsComponentController {
    constructor(_, componentRegistryService, $scope, dateTimeService) {
        this._ = _;
        this.scope = $scope;
        this.componentRegistryService = componentRegistryService;
        this.isInDeadEndState = true;
        this.modelsToFilterOn = null;        

        this.scope.$watch(() => {
            let component = this.componentRegistryService.get('giftValue');
            if (component) {
                return component.model;
            }
            return undefined;
        }, (newValue, oldValue) => {
            if (newValue) {
                this.onReportManagerQuestionsModelChanged({ giftValueType: 'giftValue', giftValue: newValue });
            } else {
                this.onReportManagerQuestionsModelChanged({ giftValueType: 'giftValue', giftValue: null });
            }
        });


        this.scope.$watch(() => {
            let component = this.componentRegistryService.get('totalValueOfGifts');
            if (component) {
                return component.model;
            }
            return undefined;
        }, (newValue, oldValue) => {
            if (newValue) {
                this.onReportManagerQuestionsModelChanged({ giftValueType: 'totalValueOfGifts', giftValue: newValue });
            } else {
                this.onReportManagerQuestionsModelChanged({ giftValueType: 'totalValueOfGifts', giftValue: null });
            }
        });

        this.commentRequired = () => true;
        this.isValidDate = dateTimeService.isValidDate;
        this.giftValueEstimateInfo = InformationText.GiftValueEstimate;
    }

    validateGiftValue(errors, value) {
        if (this.isValidGiftValue(value, 0)) {
            return true;
        }
        errors.push("Please enter a whole value (without decimal places)");
        return false;
    }

    validateTotalValueOfGifts(errors, value) {
        let defaultMinValue = GiftValue.ExecutiveGiftValue;
        let defaultErrorMsg = `Please enter a whole value (without decimal places) greater than ${GiftValue.ExecutiveGiftValue}`;
        let giftValueComponent = this.componentRegistryService.get('giftValue');
        if (giftValueComponent) {
            if (this.isValidGiftValue(giftValueComponent.model, defaultMinValue)) {
                defaultMinValue = giftValueComponent.model;
                if (!this.isValidGiftValue(value, defaultMinValue, true)) {
                    defaultErrorMsg = `Please enter a whole value (without decimal places) greater or equal to ${defaultMinValue}`;
                    errors.push(defaultErrorMsg);
                    return false;
                } else {
                    return true;
                }
            }
        } 
        if (!this.isValidGiftValue(value, defaultMinValue)) {
            errors.push(defaultErrorMsg);
            return false;
        } 
        return true;
    }

    validateDateReceivedField(errors, value) {
        let invalidDateErrorMsg = "Please enter a valid date format of DD/MM/YYYY";
        let dateReceivedComponent = this.componentRegistryService.get('dateReceived');

        if (dateReceivedComponent) {
            if (this.isValidDate(dateReceivedComponent.model)) {
                return true;              
            } else {
                errors.push(invalidDateErrorMsg);
                return false;           
            }
        }
        return true;
    }
    
    preselectOption() {
        let defaultMinValue = GiftValue.ExecutiveGiftValue;
        let giftValueComponent = this.componentRegistryService.get('giftValue');
        if (giftValueComponent) {
            if (this.isValidGiftValue(giftValueComponent.model, defaultMinValue)) {
                return true;
            } else {
                return false;
            }
        }
    }

    setRightValueForReceivedFromIndividualOrOrganization() {
        if (this.existsAndValid('giftValue')) {
            let isGiftValueGreaterThan300 = this.preselectOption();
            let component = this.componentRegistryService.get('receivedFromIndividualOrOrganisation');
            if (isGiftValueGreaterThan300) {
                if (component) {
                    component.model = true;
                }
            } 
            return true;
        } else {
            return false;
        }
    }

    existsAndValid(model) {
        return this.componentRegistryService.existsAndValid(model);
    }

    existWithValue(model, valueToCheck) {
        return this.componentRegistryService.existWithValue(model, '', valueToCheck);
    }

    showGiftDeclarationRequiredDiv() {
        let defaultMinValue = GiftValue.MinimumGiftValue;
        let giftValueComponent = this.componentRegistryService.get('giftValue');
        if (giftValueComponent) {
            if (giftValueComponent.model === null || giftValueComponent.model === undefined) {
                return false;
            }
            if (this.isValidGiftValue(giftValueComponent.model, defaultMinValue)) {
                return false;
            } else {
                return true;
            }
        }
    }

    isDeadEnd() {
        //Treat the first question not answered as a dead end
        if (!this.existsAndValid('doesAcceptanceCreateConflictOfInterest')) {
            this.isInDeadEndState = true;
            this.onIsDeadEndChanged({ isDeadEnd: this.isInDeadEndState });
            return this.isInDeadEndState;
        }


        if (this.existWithValue('doesAcceptanceCreateConflictOfInterest', true) === true) {
            this.isInDeadEndState = true;
            this.onIsDeadEndChanged({ isDeadEnd: this.isInDeadEndState });
            return this.isInDeadEndState;
        }

        this.isInDeadEndState = false;
        this.onIsDeadEndChanged({ isDeadEnd: this.isInDeadEndState });
        return this.isInDeadEndState;
    }

    validate() {
        if (this.readonly) {
            return true;
        }
        this.validateGiftValue();
    }
    
    isValidGiftValue(giftValue, minValue, isEqualCheck = false) {   
        if (giftValue) {
            let giftValueDecimal = giftValue.match(/\d*/)[0];
            if (giftValueDecimal === giftValue) {
                let intMinValue = this._.toInteger(minValue);
                let intGiftValue = this._.toInteger(giftValueDecimal);
                if (isEqualCheck && intGiftValue === intMinValue) {
                    return true;
                }
                if (intGiftValue > intMinValue) {
                    return true;
                } 
            }
        }
        return false;
    }

    onFileUploaded(disclosureFile) {
        this.onFileUpload({ disclosureFile: disclosureFile });
    }

    onFileFetched(fileDto) {
        this.onFileFetch({ fileDto: fileDto });
    }

    onFileDeleted(fileDto) {
        this.onFileDelete({ fileDto: fileDto });
    }
}

    GiftDetailsComponentController.$inject = ['_', 'componentRegistryService', '$scope', 'dateTimeService'];

export default  {
    bindings: {
        readonly: '<',
        giftStatus: '<',
        discloserFiles: '<',
        onIsDeadEndChanged:'&',
        onReportManagerQuestionsModelChanged: '&',
        onFileUpload: '&',
        onFileFetch: '&',
        onFileDelete: '&'
    },
    templateUrl: 'app/disclose/gift/components/gift-details/gift-details.html',
    controller: GiftDetailsComponentController
};


// WEBPACK FOOTER //
// ./app/disclose/gift/components/gift-details/gift-details.component.js